import * as React from 'react';
import { Video as Video$2, IframeWrapper } from './Video.styles.js';

var Video = function Video(_ref) {
  var url = _ref.url,
    iframe = _ref.iframe,
    poster = _ref.poster,
    width = _ref.width,
    height = _ref.height;
  var renderIframe = function renderIframe() {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-danger
      React.createElement(IframeWrapper, {
        width: width,
        height: height,
        dangerouslySetInnerHTML: {
          __html: iframe
        }
      })
    );
  };
  return (iframe === null || iframe === void 0 ? void 0 : iframe.length) > 0 ? renderIframe() : /*#__PURE__*/React.createElement(Video$2, {
    className: "leshen-video"
  }, /*#__PURE__*/React.createElement("video", {
    controls: true,
    srcLang: "en",
    poster: poster
  }, /*#__PURE__*/React.createElement("source", {
    src: url,
    type: "video/mp4"
  }), "Your browser does not support the video tag."));
};
var Video$1 = Video;

export { Video$1 as default };
//# sourceMappingURL=index.js.map
